module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_15_m2.c418f6611108519e69f6e6a21265f425.png";